:host {
  position: relative;

  --z-index: var(--navbar-skip-to-content-z-index, 1000);
}

.SkipToContent__trigger {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
  background: none;
  appearance: none;
  cursor: pointer;
  text-decoration: none;
}

.SkipToContent__popover {
  display: none;
  position: absolute;
  top: 10px;
  inset-inline-start: 0;
  z-index: var(--z-index);
  background-color: var(--pdt-color-surface-popover);
  padding: var(--pdt-space-50) var(--pdt-space-100) var(--pdt-space-100);
  gap: var(--pdt-space-25);
  border-radius: var(--pdt-radius-100);
  box-shadow: var(--pdt-shadow-surface-popover);
  flex-direction: column;

  &--visible {
    display: flex;
  }
}

.SkipToContent__label {
  padding: 0 var(--pdt-space-50);
  color: var(--pdt-color-text);
  font-size: var(--pdt-text-body-sm-font-size);
  font-weight: var(--pdt-font-weight-semibold);
  line-height: var(--pdt-text-body-sm-line-height);
  white-space: nowrap;
}

.SkipToContent__link {
  outline: 0;
  border: none;
  background: none;
  padding: var(--pdt-space-50);
  color: var(--pdt-color-text-link);
  font-size: var(--pdt-text-body-sm-font-size);
  line-height: var(--pdt-text-body-sm-line-height);
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
  border-radius: var(--pdt-radius-100);
  text-align: start;

  &:focus-visible {
    box-shadow: var(--pdt-shadow-focus);
    outline: none;
  }
}
